export default {
  AUTH: '/auth',
  HOME: '/home',
  LOGIN: '/auth/login',
  SETTING: '/auth/setting',
  CHANGE_PASSWORD: '/auth/change-password',
  DASHBOARD: '/dashboard',
  MEMBER_LIST: '/members',
  MEMBER_REGISTER: '/members/add-member',
  MEMBER_UPDATE: '/members/:id',
  FACE_IDS: '/face-ids/:type',
  FACE_IDS_PRIVATE: '/face-ids/private',
  FACE_IDS_CLUSTERED: '/face-ids/cluster',
  FACE_ID_DETAIL: '/face-ids/:type/:id',
  FACE_ID_EDIT: '/face-ids/:type/:id/edit',
  DATA_CHART: '/data-chart',
};
